import { ButtonPrimary, Colors, Icon, Text } from '@amelio/ui-library';
import { useState } from 'react';

import { ReplyInput } from './ReplyInput';
import { ReplyItem } from './ReplyItem';
import { CommentAnswerCard } from '../CommentAnswerCard/CommentAnswerCard';

import type { CommentItemProps } from './types';

import { useAmelioTranslations } from '@/hooks/utils/useAmelioTranslations';

export const CommentItem = ({
    comment,
    isReply = false,
    onReplySubmit,
    isSubmittingReply = false,
    className = '',
    dataTestId = 'comment-item',
}: CommentItemProps) => {
    const { t } = useAmelioTranslations();
    const [showReplyInput, setShowReplyInput] = useState<boolean>(false);

    const hasReplies = comment.replies && !isReply && comment.replies.length > 0;

    return (
        <div
            className={`m-2 w-[95%] ${className}`}
            data-testid={dataTestId}
        >
            <CommentAnswerCard
                answer={{
                    user: comment.user,
                    text: comment.text,
                    submittedAt: comment.timestamp,
                }}
                userAnswer={comment.userAnswer}
                isReply={isReply}
                dataTestId={`${dataTestId}-card`}
            />

            {hasReplies && (
                <div className={'mt-4 ml-[8%] w-[92%] space-y-4'}>
                    {comment.replies?.map((reply) => (
                        <ReplyItem
                            key={reply.id}
                            reply={reply}
                            dataTestId={`${dataTestId}-reply-${reply.id}`}
                        />
                    ))}
                </div>
            )}

            {!isReply && comment.reviewQuestionAnswerId && (
                <div className={'mt-3 ml-[10%] w-[92%]'}>
                    {!showReplyInput ? (
                        <ButtonPrimary
                            onClick={() => setShowReplyInput(true)}
                            leftIcon={
                                <Icon
                                    name={'arrow-back-square'}
                                    color={Colors.BASE_600}
                                    size={'sm'}
                                    className={'mr-2'}
                                />
                            }
                            className={
                                'items-center border-none bg-transparent p-0 shadow-none hover:bg-transparent hover:opacity-70'
                            }
                            dataTestId={`${dataTestId}-reply-action`}
                        >
                            <Text
                                color={Colors.BASE_600}
                                size={'small'}
                                weight={'medium'}
                            >
                                {t('questionResult.reply')}
                            </Text>
                        </ButtonPrimary>
                    ) : (
                        <ReplyInput
                            onSubmit={async (content) => {
                                await onReplySubmit?.(comment.reviewQuestionAnswerId!, content);
                                setShowReplyInput(false);
                            }}
                            isSubmitting={isSubmittingReply}
                            dataTestId={`${dataTestId}-reply-input`}
                        />
                    )}
                </div>
            )}
        </div>
    );
};
